import { render } from "./StyleBlock.vue?vue&type=template&id=bca8e98c"
import script from "./StyleBlock.vue?vue&type=script&lang=js"
export * from "./StyleBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__